export const hongbao = {
    hb: "红包",
    dps: "大派送",
    xdhb: "限定红包，千万福利等你来抢",
    fxhb: "分享红包，赢得更多红包奖励",
    khb: "开Biking红包",
    kqz: "开启中...",
    ylq: "已领取",
    hdwks: "活动未开始",
    hdjxz: "活动进行中",
    hdyjs: "活动已结束",
    hddjs: "活动倒计时",
    hdsj: "活动时间",
    zwhd: "暂无活动",
    hblsjlxq: "我的红包历史奖励详情",
    jxz: "进行中",
    ygq: "已过期",
    dks: "待开始",
    zwjl: "暂无奖励",
    wnmztj: "您未满足活动条件",
    wxts: "温馨提示",
    yhwcrz: "用户已完成KYC认证和手机号绑定",
    yhwcjy: "用户完成现货交易≥100 USDT或合约交易（不含杠杆）≥100 USDT或期权交易≥100 USDT或gamefi交易≥100 USDT其中一条",
    djzh: "风控或限制提币账户不能参与活动",
    hdhbjl: "获得红包奖励",
    sqbj: "手气不佳",
    dkapp: "打开APP",
    smewm: "扫描二维码",
    wchdtj: "完成活动条件，领取红包",
    fxhd: "分享活动，获得更多红包",
    jdcz: "简单操作，赚钱收益",
    hdhb: "活动红包",
    zdqj: "指定期间",
    wcjye: "完成{type}交易额{text}≥{amount}USDT",
    yhwfhtj: "红包上线前{time}内，用户无符合条件交易",
    hbsxq: "红包上线前{time}{day}内，用户{text}",
    bhgg: "不含杠杆",
    h: "或",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/zh.js